
const onlineSalesProcessActions = {
  SET_STATE: 'onlineSalesProcess/SET_STATE',
  HANDLE_STATE: 'onlineSalesProcess/HANDLE_STATE',
  GET_DATA_ONLINE_SALES_PARTY_AVAILABILITY_LIST:'onlineSalesProcess/GET_DATA_ONLINE_SALES_PARTY_AVAILABILITY_LIST',
}

export default onlineSalesProcessActions;
